import { render, staticRenderFns } from "./BasicMiscInfo.vue?vue&type=template&id=e21e051a&scoped=true&"
import script from "./BasicMiscInfo.vue?vue&type=script&lang=js&"
export * from "./BasicMiscInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21e051a",
  null
  
)

export default component.exports